import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
@Component({
  components: {
  },
})

export default class FilterBox extends Vue {
  morePull = require('/public/images/video_editor/more_pull.png');
  morePullRed = require('/public/images/video_editor/more_pull_red.png');
  moreUp = require('/public/images/video_editor/more_up.png');
  @Prop({default: () => []})
  typeList: Array<any>;
  @Prop({default: () => {}})
  activeTypeInfo: any;
  @Prop({default: ''})
  date: string;
  // 是否显示筛选标签
  showFilterTags = false;
  /**
   * 选择当前type
   * @param type
   */
  selectType(typeInfo) {
    this.showFilterTags = false;
    this.$emit('select-type', typeInfo);
  }
  handleShowDate() {
    this.$emit('show-date')
  }
  showFilter() {
    this.closeDatePopover();
    this.showFilterTags = !this.showFilterTags
  }
  restType() {
    this.$emit('reset-type')
    this.showFilterTags = false
  }
  closePopup() {
    this.showFilterTags = false
  }

  showDatePopover = false; //时间下拉
  // 时间下拉选择
  handleShowDatePopover() {
    this.showFilterTags = false;
    this.showDatePopover = !this.showDatePopover;
  }
  closeDatePopover() {
    this.showDatePopover = false;
  }
  // 选择日期，打开日期选择弹窗
  selectAllDate() {
    this.$emit('select-all-date');
  }
  resetDate() {
    this.selectAllDate();
    this.closeDatePopover();
  }
  confirmDatePicker() {
    this.closeDatePopover();
  }
}